<template>
  <div class="performance-wrapper">
    <div class="title-n-buttons">
      <h2 class="performance-title">Ticket {{ index + 1 }}</h2>
      <div class="ticket-buttons">
        <button
          class="not-selectable"
          style="color: #db384c; font-weight: 700; font-size: 18px; font-family: Raleway"
          @click="$emit('removeSubscriptionItem', couponItem.id)"
        >
          <span class="material-icons" style="color: #db384c"> delete </span>
          DELETE
        </button>
        <span class="material-icons not-selectable" @click="expanded = !expanded">
          {{ expanded ? 'expand_less' : 'expand_more' }}
        </span>
      </div>
    </div>
    <div :style="!expanded && 'display: none'">
      <div v-if="!couponItem.type.$model" class="performance-details">
        <div
          class="ticket-type-container"
          @click="$emit('updateCouponItem', { ...couponItem.$model, type: PerformanceBy.EVENT })"
        >
          <p>Performance by Event Name</p>
        </div>
        <div
          class="ticket-type-container"
          @click="
            $emit('updateCouponItem', { ...couponItem.$model, type: PerformanceBy.PREFERENCES })
          "
        >
          <p>Performance by preferences</p>
        </div>
      </div>
      <div v-else>
        <v-select
          v-if="couponItem.type.$model === PerformanceBy.EVENT"
          v-model.number="couponItem.$model.eventTemplateId"
          :items="
            eventTemplates.map(e => {
              return { ...e, id: parseInt(e.id) }
            })
          "
          item-text="title"
          item-value="id"
          label="Select Event"
          box
        />
        <div v-else>
          <select-field-multiple
            v-model="couponItem.$model.performanceTypes"
            :items="Object.values(EventPerformanceType)"
            label="Type(s) of Performance"
          />
          <select-field-multiple
            v-model="couponItem.$model.genreIds"
            :items="genres"
            item-render="name"
            item-select="id"
            label="Genre(s)"
          />
          <select-field-multiple
            v-model="couponItem.$model.tagIds"
            :items="tags"
            item-render="name"
            item-select="id"
            label="Tag(s)"
          />
        </div>
        <text-field
          v-model.number="couponItem.$model.ticketAmount"
          type="number"
          label="Ticket amount*"
          :validator="vs.ticketAmount"
        />
      </div>
    </div>
  </div>
</template>

<script>
import selectFieldMultiple from '@/components/shared/inputs/select-field-multiple.vue'
import { InterestType, EventPerformanceType, PerformanceBy } from '@/types'

export default {
  name: 'performance-container',
  components: {
    selectFieldMultiple,
  },
  props: {
    couponItem: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    vs: {
      type: Object,
      default: () => {},
    },
    eventTemplates: {
      type: Array,
      default: () => [],
    },
    interests: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: true,
      PerformanceBy,
      EventPerformanceType,
      InterestType,
      genres: this.interests.filter(interest => interest.type === InterestType.GENRE),
      tags: this.interests.filter(interest => interest.type === InterestType.TAG),
    }
  },
  methods: {},
}
</script>

<style scoped>
.performance-wrapper {
  margin-bottom: 32px;
  border: solid 2px #d9d9d9;
  border-radius: 8px;
  padding: 32px 24px;
  max-width: 684px;
}
.title-n-buttons {
  margin-bottom: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.performance-title {
  width: 50%;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
}
.ticket-buttons {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  column-gap: 3.5rem;
}
.performance-details {
  display: flex;
  column-gap: 1.5rem;
}
.not-selectable {
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
.material-icons {
  cursor: pointer;
}
.ticket-type-container {
  width: 100%;
  border-radius: 0.5rem;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  color: #0277bd;
  padding: 2rem 2rem 1rem;
  cursor: pointer;
  user-select: none;
}
</style>
